import { render, staticRenderFns } from "./MailTagComponent.vue?vue&type=template&id=12272f7d&scoped=true"
import script from "./MailTagComponent.vue?vue&type=script&lang=js"
export * from "./MailTagComponent.vue?vue&type=script&lang=js"
import style0 from "./MailTagComponent.vue?vue&type=style&index=0&id=12272f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12272f7d",
  null
  
)

export default component.exports